module.exports = __webpack_public_path__ + "VIPM9.png?2cedeea6de5d7ddf9f347daa61aaf29c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM9.png
// module id = 154
// module chunks = 0